import React from 'react'
import { SkillEnum } from '@/types'
import SKILLS from '@/constants/skills'

interface SkillShortcutProps {
  skill: SkillEnum
  level?: number
}

const SkillShortcut: React.FC<SkillShortcutProps> = ({ skill, level }) => {
  const getSkillColor = (skillType: string) => {
    switch (skillType) {
      case 'base':
        return {
          bg: 'bg-yellow-700',
          border: 'border-yellow-500'
        }
      case 'knowledge':
        return {
          bg: 'bg-purple-700',
          border: 'border-purple-500'
        }
      case 'maneuver':
        return {
          bg: 'bg-green-700',
          border: 'border-green-500'
        }
      default:
        return {
          bg: 'bg-gray-700',
          border: 'border-gray-500'
        }
    }
  }

  const colors = getSkillColor(SKILLS[skill].type)

  return (
    <div
      className={`${colors.bg} ${colors.border} w-8 h-8 rounded flex flex-col items-center justify-center text-white font-bold text-sm border font-mono`}
    >
      {level && <div className="text-base leading-none">{level}</div>}
      <div className="text-xs">{SKILLS[skill].abbreviation}</div>
    </div>
  )
}

export default SkillShortcut
